import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';

import { Field, reduxForm } from 'redux-form';

import TextField from 'components/fields/TextField';

import * as validate from 'utils/validate';

function onSubmit(values) {
  return values;
}

const TemplateNameCreateForm = ({
  handleSubmit,
  className,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    <Grid container justify="center" spacing={24}>
      <Grid item xs={12}>
        <Field
          id="Name"
          name="Name"
          label="Template Title"
          component={TextField}
          validate={[validate.required]}
          fullWidth
        />
      </Grid>
    </Grid>
  </form>
);

TemplateNameCreateForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
};

TemplateNameCreateForm.defaultProps = {
  className: '',
};

export default reduxForm({
  onSubmit,
})(TemplateNameCreateForm);



// WEBPACK FOOTER //
// ./src/components/settings/TemplateNameCreateDialog/TemplateNameCreateForm.js